import { memo } from "react";
import Screen, { type ScreenProps } from "ui/layouts/Screen";
import { ECommerce } from "ui/organizms/Home";

const ECommerceScreen = (props: ScreenProps) => (
    <Screen
        {...props}
        title='ECommerce'
    >
        <ECommerce />
    </Screen>
);

export default memo(ECommerceScreen);
